import { FullscreenOverlayContainer } from '@angular/cdk/overlay';
import { Platform } from '@angular/cdk/platform';
import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ExistingFullscreenOverlayContainer extends FullscreenOverlayContainer {
  constructor(@Inject(DOCUMENT) document: Document, _platform: Platform) {
    super(document, _platform);
  }

  public getContainerElement(): HTMLElement {
    const existingElement = document.querySelector<HTMLElement>('.cdk-overlay-container');
    if (existingElement) {
      this._containerElement = existingElement;
    }
    return super.getContainerElement();
  }

  public getFullscreenElement(): Element {
    const fullscreenElement = super.getFullscreenElement();
    if (fullscreenElement?.hasAttribute('disable-fullscreen-overlays')) {
      this._containerElement = null;
    } else {
      this.getContainerElement();
    }
    return fullscreenElement;
  }
}
